import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a6 6 0 0 1 6 -6h6a6 6 0 0 1 6 6a6 6 0 0 1 -6 6h-6a6 6 0 0 1 -6 -6","key":"svg-0"}]]

/**
 * IconCapsuleHorizontal
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2Fwc3VsZS1ob3Jpem9udGFsIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0zIDEyYTYgNiAwIDAgMSA2IC02aDZhNiA2IDAgMCAxIDYgNmE2IDYgMCAwIDEgLTYgNmgtNmE2IDYgMCAwIDEgLTYgLTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/capsule-horizontal
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCapsuleHorizontal = createReactComponent('outline', 'capsule-horizontal', 'CapsuleHorizontal', __iconNode);

export default IconCapsuleHorizontal;